import { components } from 'react-select';

const SelectValueContainer = ({ children, ...props }: any) => {
  const { getValue, hasValue } = props;
  const nbValues = getValue().length;

  if (!hasValue) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  } else if (nbValues === 1) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  } else {
    return <components.ValueContainer {...props}>{nbValues} filter seçimi</components.ValueContainer>;
  }
};

export default SelectValueContainer;
